import { RouteLocationRaw } from "vue-router";
import { UserRole } from "@/core/services/api/enums/UserRole";
import store from "@/store";
import { GuardedElement } from "@/core/config/MainMenuConfig";
import { Actions } from "@/store/enums/StoreEnums";

export interface UserMenuElement extends GuardedElement<UserMenuElement> {
  heading: () => string;
  route?: () => RouteLocationRaw;
  callback?: () => void;
  svgIcon?: string;
  fontIcon?: string;
}

export const UserMenuElements: UserMenuElement[] = [
  {
    heading: (): string => "My Profile",
    route: () => ({ name: "admin.profile" }),
    roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
    isAllowed: (): boolean => store.getters.isUserAuthenticated,
  },
  {
    heading: (): string => "My Profile",
    route: () => ({ name: "manager.profile" }),
    roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
    isAllowed: (): boolean =>
      store.getters.isUserAuthenticated &&
      !store.getters.isUserComplianceTrackingRequired,
  },
  {
    heading: (): string => "Portal Services",
    route: () => ({
      name: "manager.portal-services",
      params: {
        portal_service: store.getters.getPortalServiceFirst.value,
      },
    }),
    roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
    isAllowed: (): boolean =>
      store.getters.isUserAuthenticated &&
      !store.getters.isUserComplianceTrackingRequired &&
      store.getters.isCompanyEnabled &&
      store.getters.isCompanyFeaturePortalsEnabled &&
      store.getters.getPortalServices.length,
  },
  {
    heading: (): string => "PSP Portal",
    route: () => ({ name: "manager.psp-portal.sign-up" }),
    roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
    isAllowed: (): boolean =>
      store.getters.isUserAuthenticated &&
      !store.getters.isUserComplianceTrackingRequired &&
      store.getters.isCompanyEnabled &&
      store.getters.isCompanyFeaturePspPortalEnabled &&
      !store.getters.isCompanyPspPortalAttached,
  },
  {
    heading: (): string => "PSP Portal",
    route: () => ({ name: "manager.psp-portal.accounts" }),
    roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
    isAllowed: (): boolean =>
      store.getters.isUserAuthenticated &&
      !store.getters.isUserComplianceTrackingRequired &&
      store.getters.isCompanyEnabled &&
      store.getters.isCompanyFeaturePspPortalEnabled &&
      store.getters.isCompanyPspPortalAttached,
  },
  {
    heading: (): string => "Back To Admin",
    callback: () => store.dispatch(Actions.COMMON_AUTH_RETURN_TO_ADMIN),
    roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
    isAllowed: (): boolean =>
      store.getters.isUserAuthenticated && !!store.getters.getAdminBearerToken,
  },
  {
    heading: (): string => "Logout",
    callback: async () => {
      return store.dispatch(Actions.COMMON_AUTH_LOGOUT, { withRedirect: true });
    },
    roles: [
      UserRole.MANAGER,
      UserRole.MANAGER_READER,
      UserRole.ADMIN,
      UserRole.SUPER_ADMIN,
    ],
  },
];
